export type AlarmTimeframe = '1D' | '5D' | '1M' | '3M' | 'YTD' | '1Y' | '5Y' | 'All';

export interface AlarmTimeframeOption {
  value: AlarmTimeframe;
  label: string;
  interval: string;
  rangeSeconds: number | null;
  limit: number;
}

export const alarmTimeframes: AlarmTimeframeOption[] = [
  { value: '1D', label: '1D', interval: '30m', rangeSeconds: 24 * 60 * 60, limit: 48 },
  { value: '5D', label: '5D', interval: '1h', rangeSeconds: 5 * 24 * 60 * 60, limit: 120 },
  { value: '1M', label: '1M', interval: '4h', rangeSeconds: 31 * 24 * 60 * 60, limit: 186 },
  { value: '3M', label: '3M', interval: '1d', rangeSeconds: 92 * 24 * 60 * 60, limit: 92 },
  { value: 'YTD', label: 'YTD', interval: '1d', rangeSeconds: null, limit: 370 },
  { value: '1Y', label: '1Y', interval: '1wk', rangeSeconds: 366 * 24 * 60 * 60, limit: 53 },
  { value: '5Y', label: '5Y', interval: '9wk', rangeSeconds: 5 * 366 * 24 * 60 * 60, limit: 29 },
  { value: 'All', label: 'All', interval: '9wk', rangeSeconds: null, limit: 80 },
];

export function getAlarmTimeframe(value: AlarmTimeframe): AlarmTimeframeOption {
  return alarmTimeframes.find((option) => option.value === value) ?? alarmTimeframes[5]!;
}

export function getAlarmVisibleRange(value: AlarmTimeframe, nowSeconds = Math.floor(Date.now() / 1000)): { from: number; to: number } | null {
  if (value === 'All') return null;
  if (value === 'YTD') {
    const now = new Date(nowSeconds * 1000);
    const from = Date.UTC(now.getUTCFullYear(), 0, 1) / 1000;
    return { from, to: nowSeconds };
  }

  const option = getAlarmTimeframe(value);
  if (!option.rangeSeconds) return null;
  return { from: Math.max(0, nowSeconds - option.rangeSeconds), to: nowSeconds };
}

export function getAlarmCandleQuery(value: AlarmTimeframe, nowSeconds = Math.floor(Date.now() / 1000)): { interval: string; from?: number; to?: number; limit: number } {
  const option = getAlarmTimeframe(value);
  const range = value === 'YTD' ? getAlarmVisibleRange(value, nowSeconds) : null;
  return {
    interval: option.interval,
    ...(range ? range : {}),
    limit: option.limit,
  };
}
